export const SET_TOAST_STATE = "SET_TOAST_STATE"
export const SET_LOG_TYPE = "SET_LOG_TYPE"
export const CLOSE_TOAST = "CLOSE_TOAST"
export const OPEN_TOAST = "OPEN_TOAST"
